import PropTypes from 'prop-types';
import CurrencyProp from '../../profile/propTypes/currencyProp';

export const BonusListItemBlock = {
  STARTING_BONUS: 'starting_bonus',
  JACKPOT: 'jackpot',
  DESTINATION: 'destination',
};

export const BonusListItemType = {
  STARTING_7D: 'starting_7D',
  STARTING_30D: 'starting_30D',
  JACKPOT: 'jackpot',
  DESTINATION: 'destination',
};

export const BonusListItemStatus = {
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  UNSTARTED: 'unstarted',
};

export const RewardTypes = {
  YOUR_VA: 'yourVA',
  RECRUITMENT: 'recruitment',
  COMMISSIONS: 'commissions',
  GROUP_VA: 'groupVA',
};

const propType = {
  block: PropTypes.oneOf([
    BonusListItemBlock.STARTING_BONUS,
    BonusListItemBlock.JACKPOT,
    BonusListItemBlock.DESTINATION,
  ]).isRequired,
  type: PropTypes.oneOf([
    BonusListItemType.STARTING_7D,
    BonusListItemType.STARTING_30D,
    BonusListItemType.JACKPOT,
    BonusListItemType.DESTINATION,
  ]).isRequired,
  status: PropTypes.oneOf([
    BonusListItemStatus.COMPLETED,
    BonusListItemStatus.INCOMPLETE,
    BonusListItemStatus.UNSTARTED,
  ]),
  VAStatus: PropTypes.oneOf([
    BonusListItemStatus.COMPLETED,
    BonusListItemStatus.INCOMPLETE,
    BonusListItemStatus.UNSTARTED,
  ]),
  recruitmentStatus: PropTypes.oneOf([
    BonusListItemStatus.COMPLETED,
    BonusListItemStatus.INCOMPLETE,
    BonusListItemStatus.UNSTARTED,
  ]),
  VARewards: PropTypes.arrayOf(
    PropTypes.shape({
      coinReward: PropTypes.number.isRequired,
      minimumVA: PropTypes.number.isRequired,
    }),
  ),
  recruitmentRewards: PropTypes.shape({
    maximumRecruitments: PropTypes.number.isRequired,
    totalRecruitment: PropTypes.number.isRequired,
    coinsPerRecruitment: PropTypes.number.isRequired,
  }),
  commissionRewards: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape({
        minimumCommission: PropTypes.number.isRequired,
        commissionReward: PropTypes.number.isRequired,
      }),
      PropTypes.shape({
        minimumGroupVA: PropTypes.number.isRequired,
        voucherUrl: PropTypes.string.isRequired,
      }),
    ]),
  ),
  groupVA: PropTypes.number,
  currentVA: PropTypes.number,
  currentCommission: PropTypes.number,
  currencyInfo: PropTypes.shape(CurrencyProp.propType),
  startDate: PropTypes.number,
  endDate: PropTypes.number,
  remainingDays: PropTypes.number,
};
export default { propType };
